<template>
  <ion-page class="ion-page" main>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title class="h-f-b">{{ title }}</ion-title>
        <ion-buttons v-if="showBackButton" slot="start">
          <ion-back-button default-href="/" />
        </ion-buttons>

        <ion-buttons v-if="showMenuButton" slot="end">
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
      </ion-toolbar>

      <slot name="header"></slot>
    </ion-header>

    <ion-content class="ion-content" v-bind:color="color">
      <ion-refresher v-if="showRefresher" slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content
          pulling-icon="arrow-dropdown"
          pulling-text="Pull to refresh"
          refreshing-spinner="circles"
          refreshing-text="Refreshing..."
        ></ion-refresher-content>
      </ion-refresher>

      <slot></slot>
    </ion-content>

    <ion-footer>
      <ShiftNotice />
    </ion-footer>
  </ion-page>
</template>

<script>
import ShiftNotice from "./../components/ShiftNotice";

export default {
  name: "ionic-vue-page",
  components: {
    ShiftNotice: ShiftNotice
  },
  props: {
    title: { type: String, default: "" },
    color: { type: String, default: "light" },
    showBackButton: { type: Boolean, default: true },
    showMenuButton: { type: Boolean, default: true },
    showRefresher: { type: Boolean, default: true },
    refresh: { type: Function }
  },
  methods: {
    doRefresh(event) {
      this.refresh(event);
    }
  }
};
</script>